import ApiService from "./api.service";

class BulletinService extends ApiService {
    getBulletins() {
        return this.get(`Bulletin`);
    }

    getLatestBulletinItem() {
        return this.get(`Bulletin/latest`);
    }

    updateClickStats(id) {
        return this.post(`Bulletin/${id}/update-click-stats`);
    }
}

export default new BulletinService();
